// @ts-nocheck
import { XGTextarea } from 'xg-cl';
import * as PropTypes from 'prop-types';
import useProseSpellCheckAttributes from '../../hooks/useProseSpellCheckAttributes';

const ProseTextarea = ({ inputProps = {}, ...props }) => {
  const spellCheckAttributes = useProseSpellCheckAttributes();

  return (
    <XGTextarea
      {...props}
      {...spellCheckAttributes}
      inputProps={{
        ...inputProps,
        ...spellCheckAttributes
      }}
    />
  );
};

ProseTextarea.propTypes = {
  inputProps: PropTypes.object
};

export default ProseTextarea;
